import { render, staticRenderFns } from "./AddFoalParents.vue?vue&type=template&id=29978fc8&"
import script from "./AddFoalParents.vue?vue&type=script&lang=js&"
export * from "./AddFoalParents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports